import CMSPage from "@/components/CMSPage";
import { Zap } from "lucide-react";

export default function OnlineValuationPage() {
  return (
    <CMSPage
      pageId="online-valuation"
      defaultTitle="Instant Online Valuation"
      defaultDescription="Get an estimated value for your property in seconds. Our advanced algorithm analyzes local market data to provide you with an instant valuation."
      icon={Zap}
    />
  );
}
